<template>
  <v-dialog :value="value" persistent width="500" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-5 pr-2 pt-4 pb-2">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          DSD Validation Error
        </div>
      </v-card-title>
      <v-container fluid class="pa-0">
        <div class="px-4 pb-4 d-flex justify-center">{{ message }}</div>
        <div class="d-flex justify-center">
          <v-btn class="mb-4" color="warning" @click="close()">
            Acknowledge
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { utils } from '@/mixins/utils'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'DsdValidationModal',
  mixins: [displayAlert, utils],
  props: [
    'value',
    'message'
  ],
  computed: {},
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
<style>
.title {
  width: 73%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>